export default __webpack_public_path__ + "static/media/logo.5183127a.png";